var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "v-application v-application--is-ltr",
        "max-width": "860px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isDialogOpen,
        callback: function ($$v) {
          _vm.isDialogOpen = $$v
        },
        expression: "isDialogOpen",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "overflow-auto", attrs: { id: "discountCard" } },
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.dialogTitle))]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                {
                  staticClass: "discount-form",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      id: "discountName",
                      value: _vm.value.discountName,
                      outlined: "",
                      label: "Rabatt Name",
                    },
                    on: {
                      input: (value) => _vm.onChange("discountName", value),
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      id: "description",
                      value: _vm.value.description,
                      outlined: "",
                      label: "Rabatt Beschreibung",
                    },
                    on: {
                      input: (value) => _vm.onChange("description", value),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "discountType",
                      attrs: { "data-testid": "discount-type" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          value: _vm.value.discountType,
                          outlined: "",
                          label: "Rabatt Typ",
                          items: _vm.discountTypeOptions,
                          variant: "outlined",
                        },
                        on: {
                          input: (value) => _vm.onChange("discountType", value),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isFixedPrice
                    ? _c("v-text-field", {
                        attrs: {
                          id: "discountValue",
                          value: _vm.value.discountValue,
                          type: "number",
                          outlined: "",
                          label: "Rabatt Wert",
                          min: "0",
                        },
                        on: {
                          input: (value) =>
                            _vm.onChange("discountValue", value),
                        },
                      })
                    : _c(
                        "div",
                        { staticClass: "fixprice-grid" },
                        _vm._l(_vm.fixPriceFields, function (field) {
                          return _c("v-text-field", {
                            key: field.key,
                            attrs: {
                              id: field.key,
                              value: _vm.value[field.key],
                              type: "number",
                              outlined: "",
                              label: field.label,
                              min: "0",
                            },
                            on: {
                              input: (value) => _vm.onChange(field.key, value),
                            },
                          })
                        }),
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flatRateDiscountType",
                      attrs: { "data-testid": "flat-rate-discount-type" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          value: _vm.value.flatRateDiscountType,
                          outlined: "",
                          label: "ND Rabatt Typ",
                          items: _vm.discountTypeOptions,
                          variant: "outlined",
                        },
                        on: {
                          input: (value) =>
                            _vm.onChange("flatRateDiscountType", value),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isFlatRateFixPrice
                    ? _c("v-text-field", {
                        attrs: {
                          id: "flatRateDiscountValue",
                          value: _vm.value.flatRateDiscountValue,
                          type: "number",
                          outlined: "",
                          label: "ND Rabatt Wert",
                          min: "0",
                        },
                        on: {
                          input: (value) =>
                            _vm.onChange("flatRateDiscountValue", value),
                        },
                      })
                    : _c(
                        "div",
                        { staticClass: "fixprice-grid" },
                        _vm._l(_vm.flatRateFixPriceFields, function (field) {
                          return _c("v-text-field", {
                            key: field.key,
                            attrs: {
                              id: field.key,
                              value: _vm.value[field.key],
                              type: "number",
                              outlined: "",
                              label: field.label,
                              min: "0",
                            },
                            on: {
                              input: (value) => _vm.onChange(field.key, value),
                            },
                          })
                        }),
                        1
                      ),
                  _vm._v(" "),
                  !_vm.isFixedPrice
                    ? _c("div", { staticClass: "minimum-price-section" }, [
                        _c("div", { staticClass: "minimum-price-title" }, [
                          _vm._v("Minimum Preise"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "fixprice-grid" },
                          _vm._l(_vm.minimumPriceFields, function (field) {
                            return _c("v-text-field", {
                              key: field.key,
                              attrs: {
                                id: field.key,
                                value: _vm.value[field.key],
                                type: "number",
                                outlined: "",
                                label: field.label,
                                min: "0",
                              },
                              on: {
                                input: (value) =>
                                  _vm.onChange(field.key, value),
                              },
                            })
                          }),
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      id: "startDate",
                      value: _vm.value.startDate,
                      type: "date",
                      outlined: "",
                      label: "Rabatt Start date",
                    },
                    on: { input: (value) => _vm.onChange("startDate", value) },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      id: "endDate",
                      value: _vm.value.endDate,
                      type: "date",
                      outlined: "",
                      label: "Rabatt End date",
                    },
                    on: { input: (value) => _vm.onChange("endDate", value) },
                  }),
                  _vm._v(" "),
                  _c("v-switch", {
                    attrs: { id: "isActive", label: "Ist der Rabatt aktiv?" },
                    model: {
                      value: _vm.value.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "isActive", $$v)
                      },
                      expression: "value.isActive",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "secondary" },
                          on: { click: _vm.closeDialog },
                        },
                        [
                          _vm._v(
                            "\n                        Abbrechen\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "discount-btn",
                          attrs: {
                            color: "success",
                            disabled: _vm.disableDiscountCreation,
                            id: "createEditDiscount",
                            density: "comfortable",
                            type: "submit",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.ctaTitle) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }